<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("billing_detail_txt") }}</h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseExample" 
                    aria-expanded="false" 
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                      <p class="text-muted">{{this.forms.addwho}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{this.forms.adddate}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{this.forms.editwho}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{this.forms.editdate}}</p>
                    </div>

                    
                    
                  </div>

                </div>

                <div class="card-body">

                  <div class="row mb-3">
                    <div class="col">
                      <label class="form-label">{{$t('billingId')}}</label>
                      <input
                          type="text"
                          class="form-control"
                          id="billingId"
                          :placeholder="$t('billingId')"
                          v-model="forms.idBillingHeader"
                          disabled
                        />
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col">
                      <label class="form-label">{{$t('customerId')}}</label>
                      <input
                          type="text"
                          class="form-control"
                          id="customerId"
                          :placeholder="$t('customerId')"
                          v-model="forms.customerId"
                          disabled
                        />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">{{
                          $t('warehouseId_txt')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="warehouseId"
                          :placeholder="$t('warehouseId_txt')"
                          v-model="forms.warehouseId"
                          disabled
                        />
                    </div>
                  </div>
       
                  <div class="row mb-3">
                    <div class="col">
											<label class="form-label">{{$t('customerGroup')}}</label>
											<input
                          type="text"
                          class="form-control"
                          id="customerGroup"
                          :placeholder="$t('customerGroup')"
                          v-model="forms.customerGroup"
                          disabled
                        />
										</div>
										<div class="col-md-6">
											<label class="form-label">{{
                          $t('customerSAPCode')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="customerSAPCode"
                          :placeholder="$t('customerSAPCode')"
                          v-model="forms.customerSAPCode"
                          disabled
                        />
										</div>
                  </div>


                  <div class="row mb-3">
                    <div class="col">
                      <br>
                      <button
                    class="btn btn-light float-first"
                    type="button"
                    @click="getRateDetail()"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    {{ $t("rate_detail_txt") }}
                  </button>
                  
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">{{
                          $t('transactionDate_txt')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="transactionDate"
                          :placeholder="$t('transactionDate_txt')"
                          v-model="forms.transactionDate"
                          disabled
                        />
                    </div>
                  </div>
          
                  <div class="row mb-3">
                    <div class="col">
											<label class="form-label">{{$t('statusTxt')}}</label>
											<input
                          type="text"
                          class="form-control"
                          id="status"
                          :placeholder="$t('statusTxt')"
                          v-model="forms.status"
                          disabled
                        />
										</div>
										<div class="col-md-6">
											<label class="form-label">{{
                          $t('amount_txt')
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="amount"
                          :placeholder="$t('amount_txt')"
                          v-model="amountData"
                          disabled
                        />
										</div>
                  </div>

    
                  <div class="card-header" v-if="permision_role.method_update && forms.status == 'COMPLETED' || permision_role.method_update && forms.status == 'DRAFT' || permision_role.method_update && forms.status == 'PROCESSING'">
                    <br>
                    <br>
                     
                    <div class="row mb-3">
                      <div class="col" v-if="permision_role.method_update && forms.status == 'COMPLETED'">

                        <label class="form-label">{{$t('recalculate')}}</label>
                        <div class="row mb-3">

                          <div class="col-sm-7">
                          <date-range-picker style="width:100%" @update="recalculateDates()" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="recalculateDataDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a @click="clearrecalculateDates()" class="float-end" style="margin-right: 5px;color:red;">{{$t("clearCalender")}}</a> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span> <span v-if="header.in_selection"> - {{$t("inSelection")}}</span>
                              <br>
                            </div>
                          </date-range-picker>
                        </div>
                        <div class="col-sm-5">
                          
                          <button
                            class="
                              btn btn-info
                              text-black
                              fw-bolder
                              btn-icon-text
                            "
                            @click="destroyMassSubDetailOnlyByDate"
                            type="button"
                          >
                          <i class="link-icon mdi mdi-cloud-sync"></i>
                            {{ $t("recalculate") }}
                          </button>

                        </div>
                        </div>
                        

                      </div>

                      <div class="col-md-6">
                        <label class="form-label">{{$t('UploadTxt')}}</label>

                        <div class="row mb-3">

                          <div class="col-sm-6">
                            <button
                              class="
                                btn btn-info
                                text-black
                                fw-bolder
                                btn-icon-text
                              "
                              @click="uploadOvertime()"
                              type="button"
                            >
                            <i class="link-icon mdi mdi-cloud-upload"></i>
                              {{ $t("uploadDataOvertime") }}
                          </button>

                          </div>
                          <div class="col-sm-6">
                            <button
                              class="
                                btn btn-info
                                text-black
                                fw-bolder
                                btn-icon-text
                              "
                              @click="uploadVas()"
                              type="button"
                            >
                            <i class="link-icon mdi mdi-cloud-upload"></i>
                              {{ $t("uploadDataVAS") }}
                          </button>

                          </div>

                        </div>

                      </div>
                    </div>

                  </div>

                 
          


                  <div class="card-header">
                    <br>
                    <br>
                    
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("billing_summary_detail_txt") }}</h6>
                </div>

                  <div class="row mb-3">


                  <vue-good-table
                    title="list-billing-cli-billing-details"
                    :rows="rows"
                    :columns="columns"
                    :sort-options="{
                      enabled: true,
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                     <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="permision_role.method_read"
                              title="Detail"
                              @click.prevent="
                                detailDataDetail(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-eye" style="font-size:16px"></i>
                              
                            &nbsp;
                            </a>

                            
                      </span>
                      <span v-if="props.column.field == 'amountCategory'">
                        {{ toCurrency(props.row.amountCategory) }}                            
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>


                  </div>

                  <div class="card-footer">
                      <button
                        class="
                          btn btn-primary
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <span>&nbsp;&nbsp;</span>

                      <button
                        class="
                          btn btn-success
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="downloadData"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-cloud-download"></i>
                        {{ $t("downloadData") }}
                      </button>

                
                      <span v-if="permision_role.method_update && forms.status == 'DRAFT'">&nbsp;&nbsp;</span>

                      <button v-if="permision_role.method_update && forms.status == 'DRAFT'"
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="editData()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-grease-pencil"></i>
                        {{ $t("editMess") }}
                      </button>
                
                      <span v-if="permision_role.method_update && forms.status == 'COMPLETED'">&nbsp;&nbsp;</span>

                      <button v-if="permision_role.method_update && forms.status == 'COMPLETED'"
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="recalculateData()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-cloud-sync"></i>
                        {{ $t("recalculate") }}
                      </button>
 
                      <span v-if="permision_role.method_update && forms.status == 'COMPLETED'">&nbsp;&nbsp;</span>

                      <button v-if="permision_role.method_update && forms.status == 'COMPLETED'"
                        class="
                          btn btn-danger
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="confirmedData()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-thumb-up"></i>
                        {{ $t("confirmed") }}
                      </button>

                      <span v-if="permision_role.method_update && forms.status == 'CONFIRMED'">&nbsp;&nbsp;</span>

                      <button v-if="permision_role.method_update && forms.status == 'CONFIRMED'"
                        class="
                          btn btn-danger
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="downloadXml()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-cloud-download"></i>
                        {{ $t("downloadXml") }}
                      </button>

                      
                   </div>
                    
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->


        <!--begin::modal-->
        <modal name="formSchedulerXmlData" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">

             
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">{{this.$t("history_sync")}}</h5>
                  <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
                </div>

                <div class="modal-body">

                  <div class="mb-3">

                   
                    <h6 class="card-title">{{this.$t('historyData')}}</h6>
                    <div class="table-responsive">
                      <table v-if="this.dataSchedulerHistoryStatus" class="table table-bordered">
                      
                        <tr>
                          
                          <td>{{this.$t('statusTxt')}}</td>
                          <td>{{this.$t('file')}}</td>

                        </tr>
                        <tr v-for="item in this.dataSchedulerHistory" :key="item.id_scheduler">
                          <td>{{item.status}}</td>
                          <td><a :href="item.url_data" target="_blank">Download</a></td>
                        </tr>
                         
                      </table>
                      <table v-else class="table table-bordered">
                       
                        <tr>
                          
                          <td>{{this.$t('statusTxt')}}</td>
                          <td>{{this.$t('file')}}</td>

                        </tr>
                        <tr>
                          
                          <td colspan="2">{{$t('loadingTxt')}} ...</td>

                        </tr>
                         
                      </table>
                    </div>
                    

                  </div>


                </div>

                <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                </div>


              </div>
            </div>
          </div>
        </modal>

        <modal name="formSchedulerData" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">

                <form class="forms-sample" @submit.prevent="submitSchedulerData()" method="POST">

                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">{{this.$t("form_download_data")}}</h5>
                  <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
                </div>

                <div class="modal-body">
                    

                  <div class="mb-3">
                    <label for="emailAddress" class="form-label">{{this.$t("emailAddress")}}:</label>
                    <input type="text" class="form-control" id="emailAddress" :placeholder="$t('emailAddress')" v-model="SchedulerData.email_to" required/>
                  </div>

                  <div class="mb-3">

                   
                    <h6 class="card-title">{{this.$t('historyData')}}</h6>
                    <div class="table-responsive">
                      <table v-if="this.dataSchedulerHistoryStatus" class="table table-bordered">
                      
                        <tr>
                          
                          <td>{{this.$t('statusTxt')}}</td>
                          <td>{{this.$t('file')}}</td>

                        </tr>
                        <tr v-for="item in this.dataSchedulerHistory" :key="item.id_scheduler">
                          <td>{{item.status}}</td>
                          <td><p v-if="item.status !== 'DRAFT'"><a :href="item.url_data" target="_blank">Download</a></p></td>
                        </tr>
                         
                      </table>
                      <table v-else class="table table-bordered">
                       
                        <tr>
                          
                          <td>{{this.$t('statusTxt')}}</td>
                          <td>{{this.$t('file')}}</td>

                        </tr>
                        <tr>
                          
                          <td colspan="2">{{$t('loadingTxt')}} ...</td>

                        </tr>
                         
                      </table>
                    </div>
                    

                  </div>


                </div>

                <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                  <button type="submit" class="btn btn-primary">{{ this.$t("submitFormTxt") }}</button>
                </div>

                </form>

              </div>
            </div>
          </div>
        </modal>

        <modal name="detailRateClibilling" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{this.$t("rate_detail_txt")}}</h5>
            <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
          </div>

          <div class="modal-body">
              

            <div class="mb-3">
              <label for="rateName" class="form-label">{{this.$t("rateName_txt")}}:</label>
              <input type="text" class="form-control" id="rateName" :placeholder="$t('rateName_txt')" v-model="rateHeader.rateName" disabled/>
            </div>

            <div class="mb-3">
              <label for="warehouseId" class="form-label">{{this.$t("warehouseId_txt")}}:</label>
              <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="rateHeader.warehouseId" disabled/>
            </div>

            <div class="mb-3">
              <label for="customerId" class="form-label">{{this.$t("customerId")}}:</label>
              <input type="text" class="form-control" id="customerId" :placeholder="$t('customerId')" v-model="rateHeader.customerId" disabled/>
            </div>

            <div class="mb-3">
              <label for="customerGroup" class="form-label">{{this.$t("customerGroup")}}:</label>
              <input type="text" class="form-control" id="customerGroup" :placeholder="$t('customerGroup')" v-model="rateHeader.customerGroup" disabled/>
            </div>

            <div class="mb-3">
              <label for="customerSAPCode" class="form-label">{{this.$t("customerSAPCode")}}:</label>
              <input type="text" class="form-control" id="customerSAPCode" :placeholder="$t('customerSAPCode')" v-model="rateHeader.customerSAPCode" disabled/>
            </div>

            <div class="mb-3">
              <label for="firstBilingDate" class="form-label">{{this.$t("firstBilingDate_txt")}}:</label>
              <input type="text" class="form-control" id="firstBilingDate" :placeholder="$t('firstBilingDate_txt')" v-model="rateHeader.firstBilingDate" disabled/>
            </div>

            <div class="mb-3">
              <div class="row">

                <div class="col-sm-6">
                  <label for="effectiveFromDate" class="form-label">{{this.$t("effectiveFromDate")}}:</label>
                  <input type="text" class="form-control" id="effectiveFromDate" :placeholder="$t('effectiveFromDate')" v-model="rateHeader.effectiveFromDate" disabled/>
                </div>
                <div class="col-sm-6">
                  <label for="effectiveToDate" class="form-label">{{this.$t("effectiveToDate")}}:</label>
                  <input type="text" class="form-control" id="effectiveToDate" :placeholder="$t('effectiveToDate')" v-model="rateHeader.effectiveToDate" disabled/>
                </div>

              </div>
            </div>

            <div class="mb-3">
              <label for="status" class="form-label">{{this.$t("statusTxt")}}:</label>
              <input type="text" class="form-control" id="status" :placeholder="$t('statusTxt')" v-model="rateHeader.status" disabled/>
            </div>

            <div class="mb-3">
              <label for="addwho" class="form-label">{{this.$t("addwho")}}:</label>
              <input type="text" class="form-control" id="addwho" :placeholder="$t('addwho')" v-model="rateHeader.addwho" disabled/>
            </div>


            <div class="mb-3">
              <label for="adddate" class="form-label">{{this.$t("adddate")}}:</label>
              <input type="text" class="form-control" id="adddate" :placeholder="$t('adddate')" v-model="rateHeader.adddate" disabled/>
            </div>


            <div class="mb-3">
              <label for="editwho" class="form-label">{{this.$t("editwho")}}:</label>
              <input type="text" class="form-control" id="editwho" :placeholder="$t('editwho')" v-model="rateHeader.editwho" disabled/>
            </div>


            <div class="mb-3">
              <label for="editdate" class="form-label">{{this.$t("editdate")}}:</label>
              <input type="text" class="form-control" id="editdate" :placeholder="$t('editdate')" v-model="rateHeader.editdate" disabled/>
            </div>


            <div class="mb-3">
              <label for="editwho" class="form-label">{{this.$t("detail_rate_detail_txt")}}:</label>
              <br>


              <vue-good-table
                    title="list-billing-cli-rate-details"
                    :rows="rateDetails"
                    :columns="columnsRateDetails"
                    :sort-options="{
                      enabled: true,
                    }"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                  >
                     <template slot="table-row" slot-scope="props">
                      {{ props.formattedRow[props.column.field] }}
                    </template>
                  </vue-good-table>

            </div>



          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
          </div>

              </div>
            </div>
          </div>
        </modal>


        <modal name="uploadVas" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
    
                <form class="forms-sample" @submit.prevent="submitVas" method="POST">
                  <div class="modal-header">
                    <h5 class="modal-title" id="uploadVas">{{this.$t("upload_vas")}}</h5>
                    <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
                  </div>

                  <div class="modal-body">
                      

                    <div class="mb-3">
                      <label for="files" class="form-label">{{this.$t("file")}}:</label>
                      <input type="file" class="form-control" ref="fileVas" @change="handleFileUploadVas($event)"  required/>
                        
                      <div v-if="errors.file_vas">
                        <div
                          v-for="error in errors.file_vas"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>

                    </div>

                    <div class="mb-3">
                      <br>
                      <label for="download_template_vas" class="form-label"><a @click="downloadVasTemplate()" style="color: #6571ff;text-decoration: none;">{{this.$t("download_template_vas")}}</a></label>
                    </div>


                    <div class="mb-3" v-if="errorsVasUpload">

                      <div class="table-responsive">
                        <table class="table table-hover">

                          <thead>
                            <th>{{$t('docNo')}}</th>
                            <th>{{$t('statusTxt')}}</th>
                          </thead>
                          <tbody>
                            <tr v-for="(errorVas, index) in errorsVasUpload" :key="index">
                              <th>{{errorVas.docNo}}</th>
                              <th>{{errorVas.status}}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      
                    </div>
              

                  </div>

                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                    <button type="submit" class="btn btn-primary">{{ this.$t("UploadTxt") }}</button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </modal>


        <modal name="uploadOvertime" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">

          <form class="forms-sample" @submit.prevent="submitOvertime" method="POST">
            <div class="modal-header">
              <h5 class="modal-title" id="uploadOvertime">{{this.$t("upload_overtime")}}</h5>
              <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
            </div>

            <div class="modal-body">
                

              <div class="mb-3">
                <label for="files" class="form-label">{{this.$t("file")}}:</label>
                <input type="file" class="form-control" ref="fileOvertime" @change="handleFileUploadOvertime($event)"  required/>
                  
                <div v-if="errors.file_overtime">
                  <div
                    v-for="error in errors.file_overtime"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>

              </div>

              <div class="mb-3">
                <br>
                <label for="download_template_vas" class="form-label"><a @click="downloadOvertimeTemplate()" style="color: #6571ff;text-decoration: none;">{{this.$t("download_template_overtime")}}</a></label>
              </div>


              <div class="mb-3" v-if="errorsOvertimeUpload">


                <div class="table-responsive">
                  <table class="table table-hover">

                    <thead>
                      <th>{{$t('docNo')}}</th>
                      <th>{{$t('statusTxt')}}</th>
                    </thead>
                    <tbody>
                      <tr v-for="(errorOvertime, index) in errorsOvertimeUpload" :key="index">
                        <th>{{errorOvertime.nik}}</th>
                        <th>{{errorOvertime.status}}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
 
              </div>


            </div>

            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
              <button type="submit" class="btn btn-primary">{{ this.$t("UploadTxt") }}</button>
            </div>
          </form>

              </div>
            </div>
          </div>
        </modal>

        <!--end::modal-->


        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
  name: "CliBillingDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    return {
      opens:"center",
      locale:{
        format:"yyyy-mm-dd",
      
      },
      recalculateDataDates: {
        startDate: null,
        endDate: null
      },
      highlighted:{

          dates: [ // Highlight an array of dates
            new Date(),
          ],

      },
      dataSchedulerHistory:[],
      dataSchedulerHistoryStatus:false,
      errorsVasUpload:false,
      errorsOvertimeUpload:false,
      fileVas: '',
      fileOvertime: '',
      fetchchargeCategory:[],
      fetchchargeType:[],
      fetchrateBase:[],
      chargeCategory:"",
      chargeType:"",
      rateBase:"",
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      amountData:0,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      companyName:"",
      forms: { bt_billing_detail: [],transactionDate:"", idRateHeader: "",idBillingHeader:"" , warehouseId:"", customerId:"", customerGroup:"", customerSAPCode:"", transactionFromDate:"", transactionToDate:"", status:"", addwho:"",  editwho:"",amount:0},
      formsVas: { idBillingHeader:"", idBillingDetail:"" , file_vas:""},
      formsOvertime: { idBillingHeader:"", idBillingDetail:"" , file_overtime:""},
      billingDetail: { idbillingDetail:"", idBillingHeader: "",chargeCategory:"" , chargeType:"", amountCategory:0, addwho:"",  editwho:"", adddate:"",  editdate:""},
      rateHeader: { bm_rate_detail: [],effectiveDate:"", idRateHeader: "",rateName:"" , warehouseId:"", customerId:"", customerGroup:"", customerSAPCode:"", firstBilingDate:"", effectiveFromDate:"", effectiveToDate:"", status:"", addwho:"",  editwho:""},
      rateDetail: { idRateDetail:"", idRateHeader: "",chargeCategory:"" , chargeType:"", rateBase:"", SAPMaterialCode:"", SAPDivision:"", tier:0, tierQty:0, ratePerUnit:0, remark:"", addwho:"",  editwho:"", adddate:"",  editdate:""},
      rateDetails:[],
      SchedulerData:{type:"",email_to:"",idBillingHeader:""},
      columns: [
        {
          label: this.$t("chargeCategory_txt"),
          field: "chargeCategory",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeCategory_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("chargeType_txt"),
          field: "chargeType",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("SAPMaterialCode"),
          field: "SAPMaterialCode",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("amount_txt"),
          field: "amountCategory",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("amount_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

          {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
            filterOptions: {
              customFilter: false,
              enabled: false, 
            },
          },
      ],
      columnsRateDetails: [
        {
          label: this.$t("chargeCategory_txt"),
          field: "chargeCategory",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeCategory_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("chargeType_txt"),
          field: "chargeType",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rateBase_txt"),
          field: "rateBase",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rateBase_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("SAPMaterialCode"),
          field: "SAPMaterialCode",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("SAPMaterialCode_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("SAPDivision"),
          field: "SAPDivision",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("SAPDivision_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("tier"),
          field: "tier",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("tier_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("tierQty"),
          field: "tierQty",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("tierQty_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
   
        {
          label: this.$t("ratePerUnit"),
          field: "ratePerUnit",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("ratePerUnit_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("remarks_txt"),
          field: "remark",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("remark_filter"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rows: [],
      transactionFromDate:"",
      transactionToDate:"",
    };
  },
  watch: {},
  methods: {

    recalculateDates(){

      if(this.recalculateDataDates.startDate && this.recalculateDataDates.endDate){
        this.transactionFromDate=this.$moment(String(this.recalculateDataDates.startDate)).format('YYYY-MM-DD');
        this.transactionToDate=this.$moment(String(this.recalculateDataDates.endDate)).format('YYYY-MM-DD');
      }

    },

    clearrecalculateDates(){
      this.recalculateDates={
        startDate: null,
        endDate: null
      };
      this.transactionFromDate  = ""
      this.transactionToDate    = ""
    },

    resetForm(){
      this.fileVas                    = ""
      this.$refs.fileVas.value        = null;
      this.fileOvertime               = ""
      this.$refs.fileOvertime.value   = null;
      this.clearrecalculateDates()
    },

    submitSchedulerData(){
      this.isLoading = true;
      let formData = new FormData();
      formData.append("type", "billingReport");
      formData.append("email_to", this.SchedulerData.email_to);
      formData.append("idBillingHeader", this.SchedulerData.idBillingHeader);

      const baseURI  =  this.$settings.endPointBilling+"dashboard/cli-billing/bt-billing-detail-insert-scheduler-data";
      this.$http.post(baseURI,formData).then((response) => {
        this.isLoading = false;
        this.removeModals();
        this.success(response.data.datas.messages);
        this.resetForm();
      }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });

    },

    submitVas() {
      this.isLoading = true;
        
      let formData = new FormData();
      formData.append("file", this.fileVas);
      formData.append("idBillingHeader", this.formsVas.idBillingHeader);
      
      const baseURI  =  this.$settings.endPointBilling+"dashboard/cli-billing/bt-billing-detail-vas-charge-upload-multi";

      this.$http.post(baseURI,formData).then((response) => {
      this.isLoading = false;
      this.errorsVasUpload = response.data.datas;
      this.resetForm();
    }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
      
    },


    destroyMassSubDetailOnlyByDate() {
      this.isLoading = true;
      var params = this.$onBehind(this.$route.params.id);
      let formData = new FormData();
      formData.append("idBillingHeader", params[0]);
      formData.append("startDate", this.transactionFromDate);
      formData.append("endDate", this.transactionToDate);
      
      const baseURI  =  this.$settings.endPointBilling+"dashboard/cli-billing/delete-mass-sub-detail-only-bydate";

      this.$http.post(baseURI,formData).then((response) => {
      this.isLoading = false;
      this.success(response.data.datas.messages);
      this.loadData(params[0]);
      this.loadDataDetails(params[0]);
      this.resetForm();
    }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },

    submitOvertime() {
      this.isLoading = true;
        
      let formData = new FormData();
      formData.append("file", this.fileOvertime);
      formData.append("idBillingHeader", this.formsOvertime.idBillingHeader);
      
      const baseURI  =  this.$settings.endPointBilling+"dashboard/cli-billing/bt-billing-detail-overtime-charge-upload-multi";

      this.$http.post(baseURI,formData).then((response) => {
      this.isLoading = false;
      this.errorsOvertimeUpload = response.data.datas;
      this.resetForm();
    }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },


    submitDataEdit() {
      this.isLoading = true;
            
      const baseURI  =  this.$settings.endPointBilling + "dashboard/cli-rate/bm-rate-detail-update/"+this.billingDetail.idbillingDetail;

      var params = this.$onBehind(this.$route.params.id);
      this.billingDetail.idRateHeader  = params[0]
      if(typeof this.rateBase === 'object') {
        this.billingDetail.chargeCategory  = this.rateBase.categoryCode
        this.billingDetail.chargeType      = this.rateBase.chargeType
        this.billingDetail.rateBase        = this.rateBase.rateBase
        this.billingDetail.SAPMaterialCode = this.rateBase.materialCode
      }
 

      this.$http.patch(baseURI,this.billingDetail,{ timeout: 10000 }).then((response) => {
          this.loading();
          if(response.data.status === 200) {
              this.isLoading = false;
              this.errors = [];
              this.removeModals()
              this.success('Successfully');
              var params = this.$onBehind(this.$route.params.id);
              this.loadData(params[0]);
          }else{
              this.isLoading = false;
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
          }
      }).catch(error => {
            this.loading();
            this.isLoading = false;
            
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
      });
    },

   

    uploadVas() {
      var params = this.$onBehind(this.$route.params.id);
      this.formsVas.idBillingHeader          = params[0]
      this.$modal.show('uploadVas')
    },

    downloadVasTemplate(){

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-vas-charge-download-template-xlsx-multi";
      var file_name   = "vas-data-templates-multi.xlsx";


      return this.$http
      .get(
        baseURI,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },

    downloadOvertimeTemplate(){

      const baseURI   = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail-overtime-charge-download-template-xlsx-multi";
      var file_name   = "overtime-data-templates.xlsx";


      return this.$http
      .get(
        baseURI,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", file_name);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.fade(false);
      });
    },


    uploadOvertime(){
      var params = this.$onBehind(this.$route.params.id);
      this.formsOvertime.idBillingHeader          = params[0]
      this.$modal.show('uploadOvertime')
    },

    detailDataDetail(index,row) {
      var idBillingHeader  = this.$onRandom(row.idBillingHeader);
      var idBillingDetail  = this.$onRandom(row.idBillingDetail);
      // let url     = this.$settings.endPointApp +"billing-cli-billing/sub-detail/" +idBillingHeader+"/"+idBillingDetail+"/"+row.chargeCategory+"/"+row.chargeType
      // window.open(url, '_blank');
      window.location.href = "/billing-cli-billing/sub-detail/" +idBillingHeader+"/"+idBillingDetail+"/"+row.chargeCategory+"/"+row.chargeType
    },

    handleFileUploadVas( event ){
      this.fileVas = event.target.files[0];
    },

    handleFileUploadOvertime( event ){
      this.fileOvertime = event.target.files[0];
    },

    removeModals(){
      
      this.$modal.hide('uploadOvertime')
      this.$modal.hide('uploadVas')
      this.$modal.hide('detailRateClibilling')
      this.$modal.hide('formSchedulerData')
      this.$modal.hide('formSchedulerXmlData')
      this.errorsVasUpload                  = false
      this.fileVas                          = ""
      this.errorsOvertimeUpload             = false
      this.fileOvertime                     = ""
      this.forms.bt_billing_detail          = []
      this.forms.transactionDate            = ""
      this.forms.idRateHeader               = ""
      this.forms.idBillingHeader            = ""
      this.forms.warehouseId                = ""
      this.forms.customerId                 = ""
      this.forms.customerSAPCode            = ""
      this.forms.transactionFromDate        = ""
      this.forms.transactionToDate          = ""
      this.forms.status                     = ""
      this.forms.addwho                     = ""
      this.forms.editwho                    = ""
      this.forms.amount                     = 0
      this.rows                             = []
      this.billingDetail.idbillingDetail    = ""
      this.billingDetail.idBillingHeader    = ""
      this.billingDetail.chargeCategory     = ""
      this.billingDetail.chargeType         = ""
      this.billingDetail.amountCategory     = 0
      this.billingDetail.addwho             = ""
      this.billingDetail.editwho            = ""
      this.billingDetail.adddate            = ""
      this.billingDetail.editdate           = ""
      this.rateHeader.bt_billing_detail     = []
      this.rateHeader.effectiveDate         = ""
      this.rateHeader.idRateHeader          = ""
      this.rateHeader.rateName              = ""
      this.rateHeader.warehouseId           = ""
      this.rateHeader.customerId            = ""
      this.rateHeader.customerGroup         = ""
      this.rateHeader.customerSAPCode       = ""
      this.rateHeader.firstBilingDate       = ""
      this.rateHeader.effectiveFromDate     = ""
      this.rateHeader.effectiveToDate       = ""
      this.rateHeader.status                = ""
      this.rateHeader.addwho                = ""
      this.rateHeader.editwho               = ""
      this.rateDetails                      = []
      this.errors                           = []
      this.rateDetail.idRateDetail          = ""
      this.rateDetail.idRateHeader          = ""
      this.rateDetail.chargeCategory        = ""
      this.rateDetail.chargeType            = ""
      this.rateDetail.rateBase              = ""
      this.rateDetail.SAPMaterialCode       = ""
      this.rateDetail.SAPDivision           = ""
      this.rateDetail.tier                  = 0
      this.rateDetail.tierQty               = 0
      this.rateDetail.ratePerUnit           = 0
      this.rateDetail.remark                = ""
      this.rateDetail.addwho                = ""
      this.rateDetail.editwho               = ""
      this.amountData                       = 0
      this.formsVas.idBillingDetail         = ""
      this.SchedulerData.type               = ""
      this.SchedulerData.email_to           = ""
      this.SchedulerData.idBillingHeader    = ""


      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);
      this.loadDataDetails(params[0]);

    },


    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    openRateDetail(){
      this.$modal.show('detailRateClibilling')
    },

    getRateDetail(){
      this.isLoading  = true;
      var id          = this.forms.idRateHeader;
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-rate/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.isLoading  = false;
        this.rateHeader      = response.data.datas;
        this.rateDetails     = response.data.datas.bm_rate_detail;
        this.openRateDetail()
      }).catch(error => {
          this.isLoading = false;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });

    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/billing-cli-billing/edit/" + params;
    },


    recalculateData() {
      var params  = this.$onBehind(this.$route.params.id);
      var id      = params[0];
      
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: "RECALCULATE",
          };
          const baseURI =
          this.$settings.endPointBilling + "dashboard/cli-billing/update-header-status/"+id;
          this.$http
            .post(baseURI, formData,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData(id);
                this.loadDataDetails(id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }else{
          this.isLoading = false;
        }
      });


    },

    generateXML(id){

      this.isLoading = true;
      let formData = new FormData();
      formData.append("type", "billingXML");
      formData.append("email_to", "blank@blank.com");
      formData.append("idBillingHeader", id);

      const baseURI  =  this.$settings.endPointBilling+"dashboard/cli-billing/bt-billing-detail-insert-scheduler-data";
      this.$http.post(baseURI,formData).then(() => { });
    },

    confirmedData() {
      var params  = this.$onBehind(this.$route.params.id);
      var id      = params[0];
      
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: "CONFIRMED",
          };
          const baseURI =
            this.$settings.endPointBilling + "dashboard/cli-billing/update-header-status/"+id;
          this.$http
            .post(baseURI, formData,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData(id);
                this.loadDataDetails(id);
                this.generateXML(id);

              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
            });
        }else{
          this.isLoading = false;
        }
      });


    },


    downloadData() {
      var params                          = this.$onBehind(this.$route.params.id);
      this.SchedulerData.idBillingHeader  = params[0]
      this.SchedulerData.email_to         = this.userData.email
      // this.$modal.show('formSchedulerData')
      
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/scheduler-data?type=billingReport&idBillingHeader="+params[0];
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.dataSchedulerHistory       = response.data.datas;
        this.dataSchedulerHistoryStatus = true;
        this.$modal.show('formSchedulerData')
      }).catch(error => {
          this.dataSchedulerHistoryStatus     = true;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });
        


    },


    downloadXml() {
      var params                          = this.$onBehind(this.$route.params.id);
      this.SchedulerData.idBillingHeader  = params[0]
      
      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/scheduler-data?type=billingXML&idBillingHeader="+params[0];
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.dataSchedulerHistory       = response.data.datas;
        this.dataSchedulerHistoryStatus = true;
        this.$modal.show('formSchedulerXmlData')
      }).catch(error => {
          this.dataSchedulerHistoryStatus     = true;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });
        


    },
   

    backForm() {
      window.location.href = "/billing-cli-billing";
    },

    toCurrency (value) {
      if (typeof value !== "number") {
          return value;
      }
      var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR'
      });
      return formatter.format(value);
    },

    loadData(id) {
      this.isLoading = true;

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.forms                  = response.data.datas;
        this.forms.transactionDate  = response.data.datas.transactionFromDate+"~"+response.data.datas.transactionToDate
        this.amountData             = this.toCurrency(response.data.datas.amount);
        this.isLoading              = false;

      }).catch(error => {
          this.isLoading = false;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });
    },

    loadDataDetails(id) {
      this.isLoading = true;

      const baseURI = this.$settings.endPointBilling + "dashboard/cli-billing/bt-billing-detail/" + id+"?limit=-1";
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        this.rows                  = response.data.datas.data;
        this.isLoading              = false;
      }).catch(error => {
          this.isLoading = false;
          
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


        });
    },

      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.userData       = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BillingCliController'){

          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },
 

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.loadDataDetails(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped>

</style>
